/**
 * src/components/departmentGroup.js — ГРУПП (хэсэг доторх нэгж) сонгох Select.
 *
 * onChange(departmentcode, departmentname)
 *
 * Хэрэглэгч (2026-10-23): «хяналт шалгалтын бүх түвшинд хэсэг нэгж сонголт
 * хийгээд дахин групп сонголт хийдэг болгоё. хяналт шалгалтыг хэсэг дотроо
 * группээр хийдэг юм байна» · «25 цех, 2505 хэсэг, 250501 групп».
 *
 * ── ЯАГААД `departmentNegj.js`-ЫГ ДАХИН ХЭРЭГЛЭЭГҮЙ ────────────────────
 * Түүнд `parentCode={хэсэг}` өгвөл групп үнэндээ зөв гардаг. Гэвч:
 *   • Тэр файлын тайлбар нь «Групп (lvl 7) ба товчоо (lvl 8)-ыг ХАСНА»
 *     гэж ЗОРИУД бичсэн (2026-09-26-ны гомдол: «2501 дээр 4 илүү мөр»).
 *     Группийн сонгогч болгон давхар хэрэглэвэл тэр гэрээтэй зөрчилдөж,
 *     хожим хэн нэгэн «зөв» болгож засахад ЭНЭ сонгогч чимээгүй хоосрох.
 *   • Тэр нь «ХЭРЭГЛЭГЧИЙН ӨӨРИЙН negj»-ийг уртын шалгалтгүйгээр
 *     жагсаалтад НЭМДЭГ. Хэрэглэгчийн negj нь 2505 (хэсэг) бол тэр нь
 *     группийн жагсаалтад өөрөө орж ирнэ — хэсэг нь өөрийн групп болно.
 *   • Түүнд хэсгийн тусгай зан үйл (авто-сонголт, level-5-ийг ямар ч
 *     гүнд авах) их бий — группт шаардлагагүй.
 *
 * ── ЭХ СУРВАЛЖ (2026-10-23-нд гинжээр баталсан) ───────────────────────
 *   GET /user/department
 *     → Resources/user.py :: UserDepartmentResource
 *     → Utils/util.py :: getDepartments()
 *     → Redis `123_Departments`  (457 мөр, refreshRedis нь Warehouse_key-ээр)
 *     → [history].[reference_db].dbo.R_Departments   ← ЭРХ МЭДЭЛТЭЙ
 *   ⚠ HSE нь үүнийг ЗӨВХӨН УНШДАГ — `123_Departments`-ыг бичдэг код HSE-д
 *     нэг ч байхгүй. Нэгж дутуу бол засвар нь ХНЗХ/лавлахын эзэнд байна,
 *     HSE-ийн кодод БИШ.
 *
 * ⚠ `R_Departments01` ГЭСЭН ӨӨР ХҮСНЭГТ БИЙ (658 мөр) — түүнд 2531 · 2532
 *   · 2533 · 2534-ийн групп БАЙДАГ (253101…253104 г.м.), гэвч тэр нь
 *   ЗЭРЭГЦЭЭ/ШИНЭ бүтэц: «хэсэг» → «алба» нэршилтэй, ажилтан түүний
 *   кодоор бүртгэгддэггүй (negj_code таарц: R_Departments 303/304 код ·
 *   94.9% ажилтан, R_Departments01 ердөө 183/304 · 65.9%). Мөн 2505-ийн
 *   групп (250501 · 250502) тэнд БАЙХГҮЙ — хоёулаа нэг нь нөгөөгийнхөө
 *   дэд БИШ (457-д л 75 код, 01-д л 274 код).
 *   ⇒ ХЭРЭГЛЭГЧИЙН ШИЙДВЭР (2026-10-23): `R_Departments`-аараа явна,
 *     кодыг өөрчлөхгүй. Тэнд дутуу байгаа шалтгааныг өөр хүн олж засна.
 *     Тул энд `R_Departments01`-ыг нийлүүлэх ГЭЖ БИТГИЙ оролд.
 *
 * ── ДҮРЭМ: ЭЦГИЙН КОД + ЯГ 2 ОРОН ─────────────────────────────────────
 * Баазаас хэмжсэн (2026-10-23, R_Departments 457 мөр):
 *     25      lvl 4  Холбоо, мэдээллийн технологи…        ЦЕХ
 *     2505    lvl 5  Систем хөгжүүлэлтийн хэсэг           ХЭСЭГ
 *     250501  lvl 7  Хэрэглээний программ …-ийн групп     ГРУПП
 *
 * ⚠ ТҮВШНИЙ ДУГААРААР ШҮҮЖ БОЛОХГҮЙ. 6 оронтой 187 код нь түвшин
 *   5(9) · 6(31) · 7(47) · 8(100) гэж тархсан. Түвшин 5 хэсгүүдийн
 *   хүүхдүүд нь түвшин 7 (35) ба 8 (62) — «групп» нэртэй нь 7, Захиргааны
 *   дор «…товчоо», «Удирдлага» нь 8 боловч хэсгийн дор байдаг тул
 *   группийн сонголтод ОРОХ ёстой. Иймд ЗӨВХӨН код урт + угтвар.
 *
 * ⚠ ГРУППГҮЙ ХЭСЭГ ОЛОН: 208 хэсгийн зөвхөн 24-д групп байдаг. Тиймээс
 *   групп нь ЗААВАЛ БИШ бөгөөд хоосон үед «Групп байхгүй» гэж харуулна
 *   (`departmentNegj`-ийн «Хэсэг байхгүй»-тэй ижил конвенц) — талбарыг
 *   нуувал хэрэглэгч «яагаад гарахгүй байна» гэж эрэлхийлнэ.
 */

import React, { useEffect, useState } from "react";
import * as API from "src/api/request";
import { Select } from "antd";
import _ from "lodash";

/**
 * Сонгогдсон ГРУПП нь шинэ ХЭСЭГТ хамаарах эсэх.
 *
 * Хэсэг солигдоход группийг цэвэрлэхэд хэрэглэнэ —
 * `departmentNegj.sectionBelongsToParent`-тай ижил үүрэг.
 *
 * @returns {boolean} false бол группийг цэвэрлэх ёстой.
 */
export function groupBelongsToSection(value, sectionCode) {
  const v = String(value == null ? "" : value).replace(/\D/g, "");
  const p = String(sectionCode == null ? "" : sectionCode).replace(/\D/g, "");
  if (!v) return true; // групп сонгоогүй — цэвэрлэх зүйлгүй
  if (!p) return false; // ХЭСЭГ ХООСОН → ямар ч групп хүчингүй
  return v.startsWith(p) && v.length === p.length + 2;
}

/**
 * Бүх нэгжээс тухайн хэсгийн группүүдийг шүүнэ.
 *
 * Экспортлов: тест болон мобайлтай нэг дүрэм барихад.
 */
export function groupOptions(rows, sectionCode) {
  const p = String(sectionCode == null ? "" : sectionCode).replace(/\D/g, "");
  if (!p) return [];
  return (rows || [])
    .filter((a) => {
      const code = String(a.departmentcode || "").replace(/\D/g, "");
      return code.startsWith(p) && code.length === p.length + 2;
    })
    .sort((a, b) =>
      String(a.departmentcode).localeCompare(String(b.departmentcode)),
    );
}

const DepartmentGroup = (props) => {
  const [list, setList] = useState([]);

  useEffect(() => {
    let mounted = true; // unmount болсны дараа setState хийхээс сэргийлнэ
    const section = String(props.parentCode || "").replace(/\D/g, "");
    if (!section) {
      setList([]);
      return undefined;
    }
    // ⚠ `stage`-ыг ҮРГЭЛЖ дамжуулна: IV шатанд ӨӨР цех сонгогддог тул
    //   параметргүй дуудвал тэр цехийн нэгжүүд хэрэглэгчийн хүрээнд
    //   байхгүй болж жагсаалт хоосрох (departmentNegj-ийн тайлбар).
    API.getUserDepartment(props.stage)
      .then((res) => {
        if (!mounted) return;
        setList(groupOptions(res || [], section));
      })
      .catch(() => {
        if (mounted) setList([]);
      });
    return () => {
      mounted = false;
    };
  }, [props.parentCode, props.stage]);

  const emit = (code) => {
    if (!props.onChange) return;
    const item = _.find(
      list,
      (x) => String(x.departmentcode) === String(code),
    );
    /* ⚠ ГУРАВ ДАХЬ АРГУМЕНТ — бүтэн мөр (2026-10-26). Дуудагчид
       `id` (= `department_id`) хэрэгтэй: ажилтан ГРУПП-ийн түвшинд
       `negj_code`-оор бүртгэгддэггүй тул группийн оролцогчдыг ЗӨВХӨН
       `worker.departmentid === групп.id`-ээр шүүж олно
       (pages/morningxab/register.js). Нэмэлт аргумент тул хуучин
       дуудагчид хөндөгдөхгүй. */
    props.onChange(code || "", item ? item.departmentname : "", item || null);
  };

  return (
    <Select
      showSearch
      allowClear
      size={props.size}
      placeholder={
        !props.parentCode
          ? "Эхлээд хэсэг сонгоно уу"
          : list.length === 0
            ? "Групп байхгүй"
            : props.placeholder || "Групп сонгох"
      }
      optionFilterProp="children"
      className="w-full"
      value={props.value}
      disabled={props.disabled || !props.parentCode || list.length === 0}
      onChange={(code) => emit(code)}
    >
      {_.map(list, (item) => (
        <Select.Option
          key={item.id || item.departmentcode}
          value={item.departmentcode}
        >
          {item.departmentcode} | {item.departmentname}
        </Select.Option>
      ))}
    </Select>
  );
};

export default React.memo(DepartmentGroup);
